/* Libraries */
import React from 'react';

/* Components */
import TemplateDefaultValuesTable from './TemplateDefaultValuesTable';
import { TemplateDefaultValues } from '~/src/models';
import { Actions } from '../RowActions/RowActions';

interface Props {
  templateDefaultValues: TemplateDefaultValues[];
  empty: boolean;
  visibleItems: number;
  rowActions?: Actions<TemplateDefaultValues>;
  containedInSidebar: (item: any) => boolean;
  isAddButtonDisabled: boolean;
  getAddButtonTooltip: string | null;
  addFormTemplateToSelectionSidebar: (t: TemplateDefaultValues) => void;
  onSearchChange: (s: string) => void;
  onSortByChange: (property: string, order: number) => void;
}

const TemplateDefaultValuesList = ({
  templateDefaultValues,
  empty,
  visibleItems,
  rowActions,
  containedInSidebar,
  isAddButtonDisabled,
  getAddButtonTooltip,
  addFormTemplateToSelectionSidebar,
  onSearchChange,
  onSortByChange,
}: Props) => {
  return (
    <TemplateDefaultValuesTable
      data={templateDefaultValues}
      empty={empty}
      visibleItems={visibleItems}
      rowActions={rowActions}
      containedInSidebar={containedInSidebar}
      isAddButtonDisabled={isAddButtonDisabled}
      getAddButtonTooltip={getAddButtonTooltip}
      addFormTemplateToSelectionSidebar={addFormTemplateToSelectionSidebar}
      onSearchChange={onSearchChange}
      onSortByChange={onSortByChange}
    />
  );
};

export default TemplateDefaultValuesList;
